import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Alert, AlertContext, Confirm, ConfirmContext, Separator } from "@moreirapontocom/npmhelpers";
import Navbar from "../components/Navbar/Navbar.component";
import PageHeader from "../components/PageHeader/PageReader.component";
import PullToRefresh from "pulltorefreshjs";

import "./App.scss";

function App() {
  const navigate: any = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { confirm } = useContext(ConfirmContext);
  const { alert } = useContext(AlertContext);

  const standalone = window.matchMedia("(display-mode: standalone)").matches;

  if (standalone) {
    PullToRefresh.init({
      onRefresh() {
        window.location.reload();
      },
    });
  }

  window.addEventListener("offline", () => {
    console.log("navigator.onLine: ", navigator.onLine);
    setIsOnline(navigator.onLine);
  });

  window.addEventListener("online", () => {
    console.log("navigator.onLine: ", navigator.onLine);
    setIsOnline(navigator.onLine);
  });

  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/welcome");
    }
  }, []);

  return <>
    <PageHeader />
    <Confirm confirm={confirm} />
    <Alert alert={alert} />

    {isOnline && <Separator size={90} />}

    {!isOnline && <>
      <Separator size={70} />

      <div className="text-center mb-4">
        <small>
          <span className="fa-stack">
            <i className="fas fa-wifi fa-stack-1x"></i>
            <i className="fas fa-ban fa-stack-2x" style={{ color:"Tomato" }}></i>
          </span> You are <strong>offline</strong>
        </small>
      </div>
    </>}

    <div className="container-fluid">
      <Outlet />
    </div>

    <Navbar />
  </>
}

export default App;
